module.exports = __webpack_public_path__ + "img/dixie-hvac.a90a7cf6.jpg";